import * as CONST from "./actionTypes";

const intialState = {
  isLogin: false,
  loading: false,
  basicSettingDetails: [],
  error: null,
  changePassOtp: {},
};

const SettingReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    // ================= GET_BASIC_DETAILS =================== //

    case CONST.GET_BASIC_DETAILS:
      return {
        ...state,
        isLogin: true,
        loading: true,
        error: null,
      };
    case CONST.GET_BASIC_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        basicSettingDetails: payload,
        error: null,
      };
    case CONST.GET_BASIC_DETAILS_FAIL:
      return {
        ...state,
        loading: true,

        error: payload,
      };
    // ================= BASIC_SETTING_DETAILS =================== //

    case CONST.BASIC_SETTING_DETAILS:
      return {
        ...state,
        isLogin: true,
        loading: true,
        error: null,
      };
    case CONST.BASIC_SETTING_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        basicSettingDetails: payload,
        error: null,
      };
    case CONST.BASIC_SETTING_DETAILS_FAIL:
      return {
        ...state,
        loading: true,
        error: payload,
      };

    // ================= CHANGE_PASS_OTP =================== //

    case CONST.CHANGE_PASS_OTP:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CONST.CHANGE_PASS_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        changePassOtp: payload,
        error: null,
      };
    case CONST.CHANGE_PASS_OTP_FAIL:
      return {
        ...state,
        loading: true,
        error: payload,
      };

    // ================= CHANGE_PASS_OTP_VERIFY =================== //

    case CONST.CHANGE_PASS_OTP_VERIFY:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CONST.CHANGE_PASS_OTP_VERIFY_SUCCESS:
      return {
        ...state,
        loading: false,
        changePassOtp: payload,
        error: null,
      };
    case CONST.CHANGE_PASS_OTP_VERIFY_FAIL:
      return {
        ...state,
        loading: true,
        error: payload,
      };

    // ================= change pass admin =================== //

    case CONST.CHANGE_PASS_OTP_VERIFY:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CONST.CHANGE_PASS_OTP_VERIFY_SUCCESS:
      return {
        ...state,
        loading: false,
        changePassOtp: payload,
        error: null,
      };
    case CONST.CHANGE_PASS_OTP_VERIFY_FAIL:
      return {
        ...state,
        loading: true,
        error: payload,
      };

    default:
      return state;

      break;
  }
};

export default SettingReducer;
